import styled from "styled-components";

import Avatar from "../../../../../components/Avatar";
import { ApiCompetition, ApiCompetitionEntry } from "../../../../../types";
import { getNumberWithOrdinal } from "../../../../../utils/getNumberWithOrdinal";

type Props = { entry?: ApiCompetitionEntry; competition?: ApiCompetition };

const ScoreInfoStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: 16px;
  .label {
    font-size: 0.8rem;
    color: #666;
    margin-bottom: 2px;
  }
  .value {
    font-size: 1.1rem;
    border-radius: 8px;
    background-color: #f7f8f9;
    line-height: 1;
    padding: 6px;
    font-weight: bold;
  }
`;

const ScoreInfo = ({
  label,
  value,
}: {
  label: string;
  value?: string | number;
}) => {
  return (
    <ScoreInfoStyled>
      <div className="label">{label}</div>
      <div className="value">{value}</div>
    </ScoreInfoStyled>
  );
};

export default function EntryProfile({ competition, entry }: Props) {
  return (
    <div className="d-flex align-items-center w-100">
      {entry ? (
        <div className="flex-shrink-0">
          <Avatar user={entry?.user} size={40} />
        </div>
      ) : (
        <div
          style={{
            width: 60,
            height: 60,
            background: "#ccc",
            borderRadius: 30,
          }}
        />
      )}
      <div
        className="ms-2 flex-shrink-1 flex-grow-1 lh-sm"
        style={{ minWidth: 0 }}
      >
        <div className="mb-0 text-truncate text-overflow">
          {entry ? `${entry.user.firstName} ${entry.user.lastName}` : <br />}
        </div>
        <small className="text-muted">{entry?.category.name ?? <br />}</small>
      </div>
      {entry?.position ? (
        <ScoreInfo
          label="Position"
          value={getNumberWithOrdinal(entry?.position)}
        />
      ) : null}
      {competition?.scoringSystem === "IFSC_RANKING" ? (
        <>
          <ScoreInfo label="Tops" value={entry?.scoreTuple[0]} />
          <ScoreInfo label="Zones" value={entry?.scoreTuple[1]} />
          <ScoreInfo
            label="Tries to top"
            value={-(entry?.scoreTuple[2] ?? 0)}
          />
          <ScoreInfo
            label="Tries to zone"
            value={-(entry?.scoreTuple[3] ?? 0)}
          />
        </>
      ) : null}
      {competition?.scoringSystem === "IFSC_SPORT" ? (
        <ScoreInfo label="Score" value={entry?.score.toFixed(2)} />
      ) : null}
      {!["IFSC_RANKING", "IFSC_SPORT"].includes(
        competition?.scoringSystem || ""
      ) ? (
        <ScoreInfo label="Score" value={entry?.score.toFixed(0)} />
      ) : null}
    </div>
  );
}
